import * as api from 'da-pcc-frontend-accountmanagement-api';
import formSerialize from 'form-serialize';
import useError from './Context/ErrorContext';
import { useSuspense } from './Context/Suspensful';

const apiRoot = process.env.REACT_APP_API_ROOT;

const ApiConfiguration = new api.Configuration({

  // Specify the API root conditionally
  ...apiRoot ? { basePath: process.env.REACT_APP_API_ROOT } : {},

  // Set up custom fetch api
  fetchApi: async (input, init) => {
    const response = await fetch(input, init);

    // Redirect to login page
    if (response.status === 401)
      window.location.assign(`/logout?redirectUri=${encodeURI(window.location.pathname + window.location.search)}`);
      
    return response;
  }

});

type GenericAPI<T extends api.BaseAPI> = { new(config: api.Configuration): T };

/** Retrieve a configured API */
const withAPI = <T extends api.BaseAPI>(type: GenericAPI<T>) =>
  new type(ApiConfiguration);

/** Serialize object to JSON */
const formToJson = (form: HTMLFormElement): any =>
  formSerialize(form, { hash: true });

/** Fetch from API with suspense */
const useApi = <T extends api.BaseAPI, K>(
  type: GenericAPI<T>,
  callback: (arg: T) => Promise<K>,
  dependencies = [],
  error = "Cant load"): K => {

  const showError = useError();

  const result = useSuspense(() =>
    callback(new type(ApiConfiguration)).catch(showError.bind(null, error)),
    dependencies
  );

  return result;
}

export default withAPI;
export {
  formToJson,
  useApi
}